import { Serializable } from '@admin/core/models/serializable';

export class CvDatabaseReportModel
  implements Serializable<CvDatabaseReportModel>
{
  fromObject(object: any): CvDatabaseReportModel {
    Object.assign(this, object);
    this.stats = {};
    this.totals = {};

    if (object && object.stats) {
      var keys = Object.keys(object.stats);
      keys.forEach((k) => {
        let t = new CvDatabaseDateStats();
        t = t.fromObject(object.stats[k]);
        this.stats[k] = t;
      });
    }
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public stats: { [date: string]: CvDatabaseDateStats };

  private totals: { [field: string]: number };

  public GetTotal(field: string) {
    if (!(field in this.totals)) {
      this.totals[field] = Object.keys(this.stats)
        .map((k) => this.stats[k][field])
        .reduce((a, b) => a + b, 0);
    }
    return this.totals[field];
  }
}

export class CvDatabaseDateStats implements Serializable<CvDatabaseDateStats> {
  fromObject(object: any): CvDatabaseDateStats {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
  public applications: number;
  public cvBoxApplications: number;
  public registrations: number;
  public signins: number;
  public profileFills: number;
  public announcementsWithApply: number;
  public totalClicks: number;
  public cvBoxApplicationViews: number;
  public annApplicationViews: number;
  public matchingJobseekerViews: number;
  public invitesTotal: number;
  public invitesNotResponded: number;
  public invitesInterested: number;
  public invitesInterestedAndApplied: number;
  public invitesNotInterested: number;
}
